import { Component, ElementRef, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IFileUpload, Notes } from '@core/model/note/note';
import { AuthService } from '@core/services/auth.service';
import { NotesService } from '../../services/notes.service';
import { PageFilterHrLookup } from '@core/model/pagination/filter';
import { PageResult } from '@core/model/pagination/page-result';
import { ImageResizeService } from '@shared/services/image-resize.service';
import { map, Observable } from 'rxjs';
import { NotifyService } from '@core/services/notify.service';
import { MatTooltip } from '@angular/material/tooltip';
import { ConvertDateUtcTimezoneService } from '@shared/services/convert-date-utc-timezone.service';
import { HNotesService } from '@shared/components/h-notes/h-notes.service';
import { MongoNoteDetail } from '@shared/components/h-notes/h-notes.models';

@Component({
  selector: 'app-note',
  standalone: true,
  imports: [CommonModule,FormsModule, MatTooltip],
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.css']
})
export class NoteComponent implements OnChanges {
  @Input() note: string = '';
  ticketId:string='';
  @ViewChild('fileUpload') fileUpload!: ElementRef<HTMLInputElement>;
  @Output() descriptionChange = new EventEmitter<string>();
  @Output() filesChange = new EventEmitter<File[]>();
  @Output() isNoteSaved = new EventEmitter<{noteText:string}>();
  @Input() objectID: string = '';
  @Input() noteModuleCode:string;
  @Input() tableDivClass:string='h-450px';
  @Input() notePaddingClass:string='';
  @Input() noteCardClass:string='card h-100';
  @Input() emitValues:boolean=false;
  @Input() isCleareNote=false;
  /** When provided (e.g. from ticket facility), note dates use this timezone instead of a fixed offset. */
  @Input() parentTimeZone?: string;
  @Input() minHeight: number;
  existingUploadedFiles: IFileUpload[] = [];
  @ViewChild('messageInput')messageInput: ElementRef<HTMLTextAreaElement>;
  mentionUserIdList: string[] = [];
  lstUploadedFiles: IFileUpload[] = [];
  editCheck:Boolean;
  loading:boolean;
  isSaveBtnDisabled:boolean=false;
  editNote:Notes= new Notes();
  startDate: string = "";
  endDate: string = "";
  search: string = "";


  isFilter:boolean=false;
  createNoteSearch:string='';
  currentUserNameLetter:string;
  notesLookup: PageResult<Notes> = new PageResult<Notes>();
  notes: Notes[] = [];
  notesText:string='';
  notesAttachments:any[]=[];
  lstFiles:File[]=[];
  fileToUpload: File | null = null;
  fileUploaded: IFileUpload  = new IFileUpload();
  downloadFile: IFileUpload[] = [];
  uploadedFiles: File[] = [];

  isuploadDocument:boolean;
  attachments: ['file1.pdf', 'image.jpg'];
  totalFileSize: number;
  filters: PageFilterHrLookup = {
    pageIndex: 0,
    activeIndex: 1,
    take: 12,
    search: '',
    state: '',
  };
  resizedFiles:File[]=[];

  constructor(private authService: AuthService,
              private noteService: NotesService,
              private hNotesServie: HNotesService,
              public utcToTimeZone: ConvertDateUtcTimezoneService,
              private imageResize:ImageResizeService,
              private notifyService: NotifyService,
  ){

  }



    ngOnInit(){
     this.ticketId = this.objectID;
     this.fillNote(this.objectID);
     this.currentUserNameLetter = this.getShortName(this.authService.myName);
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes && this.isCleareNote) {
      this.resetNote();
    }
  }

  filterButtonClicked(){
    this.isFilter=!this.isFilter;
  }

  cancelSearch(){
    this.filterButtonClicked();
    if(this.startDate || this.search){
      this.startDate='';
      this.search='';
      //this.getNotesPaginatedData();
    }
    this.endDate='';
  }


  triggerFileUpload(): void {
    this.fileUpload.nativeElement.click();
  }


  removeFile(index: number): void {
    this.uploadedFiles.splice(index, 1);
    this.filesChange.emit(this.uploadedFiles);
  }


    remove(filename: string): void {

    if (this.uploadedFiles.length>0) {
      this.uploadedFiles = this.uploadedFiles.filter(file => file.name !== filename);
    }
    this.lstUploadedFiles = this.lstUploadedFiles.filter(e => e.AttachmentName !== filename);
    this.lstFiles = this.lstFiles.filter(e => e.name !== filename);

  }

  // Helper function to get local date in 24-hour format
  getLocalDate24Hour(newDate?: Date): string {

    const localDate = newDate ?? new Date();

    const formattedDate =
      `${(localDate.getMonth() + 1).toString().padStart(2,'0')}/` +
      `${localDate.getDate().toString().padStart(2,'0')}/` +
      `${localDate.getFullYear()} ` +
      `${localDate.getHours().toString().padStart(2,'0')}:` +
      `${localDate.getMinutes().toString().padStart(2,'0')}:` +
      `${localDate.getSeconds().toString().padStart(2,'0')}`;

    return formattedDate;
  }


  async OnSubmit(objectId: any, facilityTimeZone?: string) {

            const noteText = this.messageInput.nativeElement.value;
            this.isNoteSaved.emit({ noteText });
          if(this.lstUploadedFiles.length>0 && noteText === ''){
            const SavingCheck=true;
          }
          else{
            if(noteText.length>500){
              return;
            }

          }

          const tz = facilityTimeZone ?? this.parentTimeZone ?? 'utc+5';
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          });

          var newComment = new Notes();
          newComment.objectID=objectId;
          newComment.noteModuleCode= this.noteModuleCode;
          newComment.updatedOn = this.getLocalDate24Hour(this.utcToTimeZone.convertLocalTimeToUTC(currentDate, tz));

          const newCommentMessage: Notes = {
            id: '0',
            objectID:newComment.objectID,
            TicketId:this.ticketId,
            noteModuleCode:newComment.noteModuleCode,
            noteText:noteText,
            updatedOn: this.getLocalDate24Hour(this.utcToTimeZone.convertLocalTimeToUTC(currentDate, tz)),
            attachment:false,
            businessId:this.authService.businessId,
            updatedById: this.authService.id,
            noteTypeId: null,
            mentionUserIdList: this.mentionUserIdList
          };

           if(this.messageInput.nativeElement.readOnly){
            return;
           }
           else{
            if(this.editCheck){
              this.editNote.noteText=noteText;
              this.editNote.files=this.uploadedFiles!
              this.editNote.noteModuleCode= this.noteModuleCode;
              this.isSaveBtnDisabled=true;
            }

            else{
              this.isSaveBtnDisabled=true;
              this.mentionUserIdList = [];
              if(this.noteModuleCode == 'TKT'){
                await this.noteService
                .addTicketNote(newCommentMessage, this.lstFiles,this.mentionUserIdList)
                .then(() => {
                  this.loading = false;
                  this.isSaveBtnDisabled=false;
                  this.resetNote();
                })
                .catch((err) => {
                  this.isSaveBtnDisabled=false;
                  this.errorNotification("Failed to save note, please try again.","Upload");
                  // this.showErrorMessage(err);
                  this.loading = false;
                });
              }
              else{
                await this.noteService
                .addNote(newCommentMessage, this.lstFiles,this.mentionUserIdList)
                .then(() => {
                  this.loading = false;
                  this.isSaveBtnDisabled=false;
                  this.resetNote();
                })
                .catch((err) => {
                  this.isSaveBtnDisabled=false;
                  this.errorNotification("Failed to save note, please try again.","Upload");
                  // this.showErrorMessage(err);
                  this.loading = false;
                });
              }

            }

           }

      }



    resetNote(){
      this.messageInput.nativeElement.value = '';
      this.messageInput.nativeElement.readOnly  = false;
      this.startDate='';
      this.endDate='';
      this.search='';
      this.editCheck=false;
      this.isSaveBtnDisabled=false;
      this.lstUploadedFiles = [];
      this.existingUploadedFiles=[];
      this.uploadedFiles=[];
      this.lstFiles = [];

    }


    async fillNote(objectId: string): Promise<void> {
      if (!objectId) {
        return;
      }
      const notes = await this.hNotesServie.getNotes(objectId);
      if (!notes?.length) {
        return;
      }
      const latest = [...notes].sort(
        (a, b) =>
          new Date(b.updatedOn).getTime() - new Date(a.updatedOn).getTime()
      )[0];
      this.edit(this.mongoNoteToNotes(latest));
    }

    private mongoNoteToNotes(api: MongoNoteDetail): Notes {
      const note = new Notes();
      note.id = api.noteId;
      note.objectID = api.objectId;
      note.businessId = api.businessId;
      note.noteText = api.noteText;
      note.noteTypeId = api.noteTypeId ?? undefined;
      note.noteModuleCode = api.noteModuleCode;
      note.updatedOn = api.updatedOn;
      note.userName = api.userName ?? api.createdByUserName ?? undefined;
      note.userPic = api.userPic ?? api.createdByUserPic ?? undefined;
      note.attachments = (api.attachments ?? []).map((a) => ({
        path: a.attachmentUrl,
      }));
      return note;
    }

    edit(item:Notes){
       this.messageInput.nativeElement.value=item.noteText;
      this.messageInput.nativeElement.readOnly  = false;
        this.isSaveBtnDisabled=false;
        this.editCheck=true;
        //this.messageInput.nativeElement.style.height='100px';
        this.editNote=item;
        this.lstUploadedFiles=[];
        this.existingUploadedFiles=[];
        item.attachments?.forEach(x => {
          const uploadItem = new IFileUpload();
                        uploadItem.AttachmentName = this.getFileName(x.path) as string;
                        uploadItem.AttachmentBlobName = x.path as string;
                        this.lstUploadedFiles.push(uploadItem);
                        this.existingUploadedFiles.push(uploadItem);
        });
     }


    getFileName(fullpath:string):string{
        return fullpath.split('/').pop()!;
    }


    getShortName(name: string) {
        var nameArr = name.split(' ');
        return Array.from(nameArr[0])[0];
      }



    onInputChange(name:any): void {
      this.notesText = name;
      }



    // async handleFileInput(event: any) {
    // const files: File[] = Array.from(event.target.files);
    // const existingFiles: File[] = Array.from(this.lstFiles || []);

    // const existingFileNames = new Set(existingFiles.map(file => file.name));

    // const duplicateFiles: File[] = files.filter(newFile => existingFileNames.has(newFile.name));
    // const uniqueFiles: File[] = files.filter(newFile => !existingFileNames.has(newFile.name));

    // if (duplicateFiles.length > 0) {
    //   const duplicateFileNames = duplicateFiles.map(file => file.name).join(', ');
    //   this.errorNotification(
    //     `The following files already exist and were skipped: ${duplicateFileNames}`,
    //     'File Duplication Error'
    //   );
    // }

    // const allowedTypes = [
    //   'image/jpeg',
    //   'image/png',
    //   'image/svg+xml',
    //   'image/gif'
    // ];

    // const validFiles = uniqueFiles.filter(file => allowedTypes.includes(file.type));
    // const invalidFiles = uniqueFiles.filter(file => !allowedTypes.includes(file.type));

    // if (invalidFiles.length > 0) {
    //   const invalidFileNames = invalidFiles.map(f => f.name).join(', ');
    //   this.errorNotification(
    //     `Unsupported file types were skipped: ${invalidFileNames}`,
    //     'File Type Error'
    //   );
    // }

    // if ((existingFiles.length + validFiles.length) > 10) {
    //   this.errorNotification('You cannot attach more than 10 files in a go.', 'Files Length Error');
    //   return;
    // }

    // const resizePromises = validFiles.map(file =>
    //   this.imageResize.resizeImage(file, 800, 800, 0.7)
    // );

    // const resizedFiles = await Promise.all(resizePromises);
    // this.resizedFiles = resizedFiles.filter(file => file !== null) as File[];

    // const combinedFiles: File[] = existingFiles.concat(this.resizedFiles);
    // this.lstFiles = combinedFiles;

    // this.isuploadDocument = false;

    // if (this.lstFiles.length > 0) {
    //   this.lstUploadedFiles = []; // Reset before pushing new items
    //   this.totalFileSize = 0;

    //   for (let i = 0; i < this.lstFiles.length; i++) {
    //     this.fileToUpload = this.lstFiles[i];

    //     const fileType = this.fileToUpload.type;
    //     const isBlockedType =
    //       fileType === 'application/x-msdownload' || fileType === 'application/exe';

    //     if (isBlockedType) {
    //       this.errorNotification('Executable files are not allowed.', 'Invalid File Type');
    //       return;
    //     }

    //     const name = this.fileToUpload.name;
    //     const uploadItem = new IFileUpload();
    //     uploadItem.AttachmentName = name;
    //     uploadItem.AttachmentBlobName = 'notfound';
    //     this.lstUploadedFiles.push(uploadItem);

    //     this.totalFileSize += this.fileToUpload.size;

    //     if (this.totalFileSize <= 4194304) { // 4 MB
    //       this.isuploadDocument = true;
    //     } else {
    //       this.isuploadDocument = false;
    //       this.errorNotification('Total file size exceeds 4MB.', 'File Size Error');
    //       return;
    //     }
    //   }

    //   // Remove duplicate file names
    //   this.lstUploadedFiles = this.lstUploadedFiles.filter((file, index, self) =>
    //     index === self.findIndex(f => f.AttachmentName === file.AttachmentName)
    //   );
    // }

    // event.target.value = ''; // reset input
    // }
async handleFileInput(event: any) {
  const files: File[] = Array.from(event.target.files);
  const existingFiles: File[] = Array.from(this.lstFiles ?? []);
  const existingFileNames = new Set(existingFiles.map((file) => file.name));
  const supportedTypes = [
    'image/jpeg',
    'image/png',
    'image/heic',
    'image/heif',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ];
  const supportedExtensions = ['.jpg', '.jpeg', '.png', '.heic', '.pdf', '.doc', '.docx', '.xls', '.xlsx'];

  const isSupported = (file: File): boolean => {
    const fileExt = file.name.split('.').pop()?.toLowerCase();
    return (
      supportedTypes.includes(file.type) ||
      (fileExt && supportedExtensions.includes(`.${fileExt}`))
    );
  };

  const skippedDuplicateFiles: string[] = [];
  const skippedUnsupportedFiles: string[] = [];
  const validFiles: File[] = [];

  // Step 1: Validate and skip unsupported or duplicates
  for (const file of files) {
    if (!isSupported(file)) {
      skippedUnsupportedFiles.push(`${file.name}`);
      continue;
    }
    if (existingFileNames.has(file.name)) {
      skippedDuplicateFiles.push(`${file.name}`);
      continue;
    }
    validFiles.push(file);
  }

  // Step 2: Enforce file count limit (max 10)
  const allowedSlots = 10 - existingFiles.length;
  const acceptedFiles = validFiles.slice(0, allowedSlots);
  const extraFiles = validFiles.slice(allowedSlots);
const skippedExtraFiles: string[] = [];
  if (extraFiles.length > 0) {
    skippedExtraFiles.push(
      ...extraFiles.map((file) => `${file.name} `)
    );
  }

  // Step 3: Resize image files
  const imageTypes = ['image/jpeg', 'image/png', 'image/heic', 'image/heif'];
  const imageFiles = acceptedFiles.filter((file) => imageTypes.includes(file.type));
  const pdfFiles = acceptedFiles.filter((file) => !imageTypes.includes(file.type));

  const resizePromises = imageFiles.map((file) =>
    this.imageResize.resizeImage(file, 800, 800, 0.7)
  );
  const resizedImages = await Promise.all(resizePromises);
  this.resizedFiles = resizedImages.filter((file) => file !== null);

  // Step 4: Final file list
  this.lstFiles = existingFiles.concat(this.resizedFiles, pdfFiles);
  this.isuploadDocument = false;

  for (const file of this.lstFiles) {
    if (!isSupported(file)) continue;

    const uploadItem = new IFileUpload();
    uploadItem.AttachmentName = file.name;
    uploadItem.AttachmentBlobName = 'notfound';
    this.lstUploadedFiles.push(uploadItem);

    this.totalFileSize += file.size;
    this.isuploadDocument = this.totalFileSize <= 4194304;
  }

  // Step 5: Remove duplicates
  this.lstUploadedFiles = this.lstUploadedFiles.filter(
    (file, index, self) =>
      index === self.findIndex((f) => f.AttachmentName === file.AttachmentName)
  );

  // Step 6: Show skipped file errors
  if (skippedDuplicateFiles.length > 0) {
    this.errorNotification(
      `The following files were already selected and have been skipped: ${skippedDuplicateFiles.join(', ')}`,
      'Duplicate Files Skipped'
    );
  }
  if (skippedUnsupportedFiles.length > 0) {
    this.errorNotification(
      `The following files have unsupported formats and were skipped: ${skippedUnsupportedFiles.join(', ')}`,
      'Unsupported File Type(s)'
    );
  }
if(skippedExtraFiles.length>0){
  this.errorNotification(
        `Only 10 files can be uploaded at a time. The following files were skipped: ${skippedExtraFiles.join(', ')}`,
        'Upload Limit Exceeded'
      );
}
  // Step 7: Upload

  event.target.value = '';
  this.filesChange.emit(this.lstFiles);
}



    resizeImage(file: File, maxWidth: number, maxHeight: number, quality: number): Promise<File> {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = URL.createObjectURL(file);
          img.onload = ()  => {
            const canvas = document.createElement('canvas');
            let width = img.width;
            let height = img.height;

            if (width > height) {
              if (width > maxWidth) {
                height = Math.round((height *= maxWidth / width));
                width = maxWidth;
              }
            } else {
              if (height > maxHeight) {
                width = Math.round((width *= maxHeight / height));
                height = maxHeight;
              }
            }

            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
              blob => {
                resolve(new File([blob], file.name, {
                  type: 'image/jpeg',
                  lastModified: Date.now()
                }));
              },
              'image/jpeg',
              quality
            );
          };
          img.onerror = err => reject(err);
        });
    }

    truncateFileName(fileName: string): string {
        const maxLength = 15;
      const fileType = fileName.split('.').pop(); // Get file extension
      const fileNameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.'));
      const truncatedName = fileName.length > maxLength ? fileNameWithoutExt.slice(0, maxLength-2) + '....' + fileType: fileName;
      return `${truncatedName}`;
    }



  notesLookup$: Observable<PageResult<Notes>>;
  findNoteById(id: string): Observable<Notes | undefined> {
    return this.notesLookup$.pipe(
        map(pageResult => {
            // Check if data exists and is an array
            if (pageResult.data && Array.isArray(pageResult.data)) {
                // Find the note with the given ID
                return pageResult.data.find(note => note.id === id);
            } else {
                return undefined;
            }
        })
    );
  }



    getNoteLength(){
      const noteText = this.messageInput.nativeElement.value;
                this.isNoteSaved.emit({ noteText });
                return noteText.length;
    }



       downloadNoteFile(event:any){
        var resp= this.noteService.downloadMyFile(event);
      }



      colorsClass: string[] = [
        'bg-danger',
        'bg-warning',
        'bg-success',
        'bg-dark',

      ];
      currentColorPickedIndex:number=0;
      getAlternateColorClass() {
        if (this.currentColorPickedIndex + 1 > this.colorsClass.length - 1) {
          this.currentColorPickedIndex = 0;
        } else {
          this.currentColorPickedIndex = this.currentColorPickedIndex + 1;
        }
        return this.colorsClass[this.currentColorPickedIndex];
      }

@ViewChild('messageInput') messageInputRef!: ElementRef<HTMLTextAreaElement>;
@ViewChild('fileUpload') fileUploadRef!: ElementRef<HTMLInputElement>;

clearDescription(): void {
  if (this.messageInputRef) {
    this.messageInputRef.nativeElement.value = '';
  }
}

clearAttachments(): void {
    this.lstUploadedFiles = []; // Clear the files list
    this.resetNote();
    if (this.fileUploadRef) {
      this.fileUploadRef.nativeElement.value = ''; // Reset file input buffer
    }
}

// showSuccessMessage() {
//         this.notifyService.success({
//           crud: this.editCheck ? UserAction.Crud.update : UserAction.Crud.create,
//           object: SystemObject.notes,
//         });
//       }

      showErrorMessage(error: any) {
        error = error.graphQLErrors[0];
        this.notifyService.error({
          message: error.message,
          type: error.extensions.type,
        });
      }

errorNotification(eMessage:string, eType:string){
        this.notifyService.error({
          message: eMessage,
          type: eType,
        });
      }


}
